import { v4 as uuid } from 'uuid';

import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map, tap, take } from 'rxjs/operators';

import { ApLoggingService } from '@ap/logging';
import { ApWindowService } from '@ap/cdk';

import { Payload } from './channel.model';

@Injectable({ providedIn: 'root' })
export class ApWebContainerChannelService {
    private readonly windowService = inject(ApWindowService);
    private readonly loggingService = inject(ApLoggingService);

    /**
     * Post data to the window
     */
    public post(messageType: any, data?: any): string {
        const payload: Payload = {
            id: uuid(),
            type: messageType
        };

        if (data) {
            payload.data = data;
        }

        this.loggingService.log('postMessage', payload);
        this.postToWindow(payload);

        return payload.id;
    }

    /**
     * Get correct response by payload id
     */
    public getResponse<T>(id: string): Observable<T> {
        return this.receive().pipe(
            filter((payload) => payload.id === id),
            take(1),
            map((payload) => payload.data as T)
        );
    }

    /**
     * Recieve data from window being posted
     */
    public receive(): Observable<Payload> {
        return this.windowService.receiveMessage().pipe(
            tap((messageEvent: MessageEvent) => this.loggingService.log('receiveMessage', messageEvent.data)),
            map((messageEvent: MessageEvent) => messageEvent.data as Payload)
        );
    }

    private postToWindow(payload: Payload): void {
        if (this.windowService.mobile) {
            this.windowService.mobilePostMessage(JSON.stringify(payload));
        } else {
            this.windowService.parentPostMessage(JSON.stringify(payload));
        }
    }
}
